import { render, staticRenderFns } from "./AdminRegionsSubMenusLinks.vue?vue&type=template&id=26e33f7d"
import script from "./AdminRegionsSubMenusLinks.vue?vue&type=script&lang=js"
export * from "./AdminRegionsSubMenusLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e33f7d')) {
      api.createRecord('26e33f7d', component.options)
    } else {
      api.reload('26e33f7d', component.options)
    }
    module.hot.accept("./AdminRegionsSubMenusLinks.vue?vue&type=template&id=26e33f7d", function () {
      api.rerender('26e33f7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/sub-menus/regions/AdminRegionsSubMenusLinks.vue"
export default component.exports